export enum BuPathEnum {
  DIST = 'DISTRIBUTION',
  GEN = 'GENERATION',
  TRANS = 'TRANSMISSION',
  FORS = 'FORESTRY',
  PROJ = 'PROJSOLUTIONS',
}
